// client/api/services/operatorPayoutService.ts
// KX-22 (model A) — ledger-based operator payouts. The withdrawable balance is
// DERIVED from the ledger (the backend owns the calculation); the UI only sends
// integer minor units + the collection currency.
import { apiClient } from "../client";
import { ENDPOINTS } from "../endpoints";

export interface PayoutBalance {
  currency: string;
  /** Integer minor units, as a string (BigInt-safe). */
  balanceMinor: string;
}

export interface Payout {
  id: string;
  amountMinor: string | null;
  currency: string;
  method: string;
  status: string;
  createdAt?: string;
}

export interface PayoutBreakdown {
  currency: string;
  balanceMinor: string;
  byAccount: {
    acquisitionMinor: string;
    servicePoolMinor: string;
    standbyMinor: string;
    payoutMinor: string;
  };
  byNode: {
    hotspotId: string;
    name: string | null;
    acquisitionMinor: string;
    servicePoolMinor: string;
  }[];
}

export const getPayoutBreakdown = async (currency: string): Promise<PayoutBreakdown | null> => {
  const res = await apiClient.get(ENDPOINTS.OPERATOR.PAYOUTS_BREAKDOWN, { params: { currency } });
  return res.data?.data || null;
};

export const getPayoutBalance = async (currency: string): Promise<PayoutBalance | null> => {
  const res = await apiClient.get(ENDPOINTS.OPERATOR.PAYOUTS_BALANCE, { params: { currency } });
  return res.data?.data || null;
};

export const requestPayout = async (payload: {
  amountMinor: string;
  currency: string;
  method: string;
  details?: Record<string, unknown>;
}): Promise<{ success?: boolean; message?: string; code?: string; data?: Payout }> => {
  const res = await apiClient.post(ENDPOINTS.OPERATOR.PAYOUTS, payload);
  return res.data;
};

export const listPayouts = async (): Promise<Payout[]> => {
  const res = await apiClient.get(ENDPOINTS.OPERATOR.PAYOUTS);
  const d = res.data?.data;
  return Array.isArray(d) ? d : [];
};
